"use client";

import { ActiveDocument, useActiveDocuments } from "@entities/common";
import { Employer, EmployerType, GovernmentEmployer, GovernmentEmployerDocumentRegistrationItem } from "@entities/employer";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { DocumentIcon } from "@heroicons/react/24/solid";
import { useStorageFile } from "@shared/storage";
import { StorageBucket } from "@sisnaker-react-core/karirhub-model-type";
import React from "react";

export function GovernmentEmployerDocumentDetails({ employer }: { employer: Employer }) {
  const government = employer.employerable as GovernmentEmployer;

  const { activeDocuments } = useActiveDocuments({ filters: { employerType: EmployerType.GOVERNMENT } });
  const documents: { document: ActiveDocument | undefined; item: GovernmentEmployerDocumentRegistrationItem | undefined }[] =
    activeDocuments
      .filter((it) => government.documents.some((doc) => doc.documentId === it.id))
      .map((it) => {
        return {
          document: it,
          item: government.documents.find((doc) => doc.documentId === it.id),
        };
      });

  const { getFiles } = useStorageFile();
  const documentFiles = getFiles({
    bucket: StorageBucket["karirhub-employer-documents"],
    fileIds: government?.documents?.filter((it) => !!it.fileId)?.map((document) => document.fileId) || [],
  });

  if (!employer || !government) return <></>;

  if (!documentFiles?.data || (documentFiles?.data && documentFiles?.data?.length <= 0)) {
    return <></>;
  }

  return (
    <div className="space-y-6">
      {documents.map((doc) => {
        const check = documentFiles.data?.find((it) => it.id === doc.item?.fileId);
        if (check) {
          return (
            <div key={check.id}>
              <div className="text-sm text-gray-500">{doc.document?.name}</div>
              <div className="mt-2 flex items-start gap-4">
                <div className="flex-1 flex items-start gap-2">
                  <DocumentIcon className="text-gray-500 size-5 min-w-5" />
                  <span className="text-sm font-medium">{check.name}</span>
                </div>
                <a className="size-4 min-w-4 text-gray-500" href={check.download_link} target="_blank">
                  <ArrowDownTrayIcon className="size-4 min-w-4 text-gray-500" />
                </a>
              </div>
            </div>
          );
        }

        return <React.Fragment key={doc.document?.id}></React.Fragment>;
      })}
    </div>
  );
}
